(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/marketplace/create-game/assets/javascripts/draw-selection.js') >= 0) return;  svs.modules.push('/components/marketplace/create-game/assets/javascripts/draw-selection.js');
"use strict";

function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }

const _React = React,
  useCallback = _React.useCallback,
  useState = _React.useState,
  useEffect = _React.useEffect,
  useRef = _React.useRef;
const _ReactRedux = ReactRedux,
  useSelector = _ReactRedux.useSelector,
  useDispatch = _ReactRedux.useDispatch;
const _ReactRouterDOM = ReactRouterDOM,
  useParams = _ReactRouterDOM.useParams,
  useLocation = _ReactRouterDOM.useLocation,
  useHistory = _ReactRouterDOM.useHistory;
const _svs$ui$ReactDropdown = svs.ui.ReactDropdown,
  DropdownSelectItem = _svs$ui$ReactDropdown.DropdownSelectItem,
  DropdownItem = _svs$ui$ReactDropdown.DropdownItem,
  DropdownLabel = _svs$ui$ReactDropdown.DropdownLabel;
const formatDate = svs.components.lbUtils.helpers.formatDate.formatDate;
const formatCurrency = svs.utils.format.Currency;
const getDraw = svs.components.marketplaceData.selectors.draws.getDraw;
const selectDraw = svs.components.marketplaceData.createGame.actions.selectDraw;
const getDrawItems = svs.components.marketplaceData.createGame.helpers.getDrawItems;
const resolveProductId = svs.utils.products.resolveProductId;
const JackPotAndFunds = svs.components.lbUi.jackpotAndFunds.JackPotAndFunds.JackPotAndFunds;
const getProductItems = svs.components.marketplaceData.createGame.helpers.getProductItems;
const DrawItemInfo = _ref => {
  let item = _ref.item,
    isEdit = _ref.isEdit,
    _ref$className = _ref.className,
    className = _ref$className === void 0 ? '' : _ref$className,
    _ref$showNetSale = _ref.showNetSale,
    showNetSale = _ref$showNetSale === void 0 ? false : _ref$showNetSale;
  const name = item.drawComment || item.name;
  const ariaLabel = "".concat(name, " Spelstopp ").concat(formatDate(new Date(item.regCloseTime), true, true, false));
  if (isEdit) {
    return React.createElement("p", {
      "aria-label": ariaLabel,
      className: "f-200 select-draw-line-height ".concat(className).trim(),
      role: "text"
    }, React.createElement("span", {
      "aria-hidden": "true",
      className: "draw-selection-item-name qa-draw-selection-item-name"
    }, "".concat(name, " Spelstopp ").concat(formatDate(new Date(item.regCloseTime), true, true, false))));
  }
  return React.createElement("p", {
    "aria-label": ariaLabel,
    className: "f-200 select-draw-line-height ".concat(className).trim(),
    role: "text"
  }, React.createElement("span", {
    "aria-hidden": "true",
    className: "f-medium f-uppercase draw-selection-item-name qa-draw-selection-item-name"
  }, name), React.createElement("span", {
    "aria-hidden": "true",
    className: "f-normal overflow-threedots"
  }, "Spelstopp ".concat(formatDate(new Date(item.regCloseTime), true, true, false))), showNetSale && React.createElement(React.Fragment, null, React.createElement("br", null), React.createElement("span", {
    className: ""
  }, "Oms\xE4ttning: ".concat(formatCurrency(item.currentNetSale), " kr"))));
};
const DrawSelection = () => {
  const dispatch = useDispatch();
  const _useParams = useParams(),
    activatedDrawId = _useParams.activatedDrawId;
  const location = useLocation();
  const history = useHistory();
  const _useState = useState(),
    _useState2 = _slicedToArray(_useState, 2),
    productItems = _useState2[0],
    setProductItems = _useState2[1];
  const _useState3 = useState(null),
    _useState4 = _slicedToArray(_useState3, 2),
    localSelectedDraw = _useState4[0],
    setLocalSelectedDraw = _useState4[1];
  const prevProductItemsRef = useRef();
  const hasInitializedRef = useRef(false);

  const queryParams = new URLSearchParams(location.search);
  const queryDrawNumber = queryParams.get('drawNumber');
  const _useSelector = useSelector(state => state.Draws),
    draws = _useSelector.draws;
  const _useSelector2 = useSelector(state => state.CreateGame || {}),
    isSelectedDrawClosed = _useSelector2.isSelectedDrawClosed,
    selectedDraw = _useSelector2.selectedDraw,
    selectedProduct = _useSelector2.selectedProduct;

  useEffect(() => {
    if (!hasInitializedRef.current) {
      if (queryDrawNumber) {
        setLocalSelectedDraw(parseInt(queryDrawNumber, 10));
        hasInitializedRef.current = true;
      } else if (selectedDraw !== 0 && selectedDraw !== undefined) {
        setLocalSelectedDraw(selectedDraw);
        hasInitializedRef.current = true;
      } else if (selectedProduct && draws[selectedProduct] && !selectedDraw && !queryDrawNumber) {
        const drawItems = getDrawItems(draws[selectedProduct]);
        const firstAvailableDraw = drawItems.find(_ref2 => {
          let isDisabled = _ref2.isDisabled;
          return !isDisabled;
        });
        if (firstAvailableDraw) {
          setLocalSelectedDraw(firstAvailableDraw.item.drawNumber);
          hasInitializedRef.current = true;
        }
      }
    }
  }, [selectedDraw, queryDrawNumber, selectedProduct, draws]);

  useEffect(() => {
    hasInitializedRef.current = false;
  }, [selectedProduct]);
  const draw = useSelector(state => getDraw(state, {
    drawNumber: localSelectedDraw || (queryDrawNumber ? parseInt(queryDrawNumber, 10) : selectedDraw),
    productName: selectedProduct
  }));
  const onSelectDraw = useCallback(drawNumber => {
    const drawItems = getDrawItems(draws[selectedProduct]);
    const isDrawDisabled = drawItems.some(_ref3 => {
      let item = _ref3.item,
        isDisabled = _ref3.isDisabled;
      return drawNumber === item.drawNumber && isDisabled;
    });
    if (!isDrawDisabled) {
      setLocalSelectedDraw(drawNumber);
      dispatch(selectDraw(drawNumber));
    }
    if (queryDrawNumber) {
      const newParams = new URLSearchParams(location.search);
      newParams.set('drawNumber', String(drawNumber));
      const newSearch = newParams.toString();
      history.replace({
        pathname: history.location.pathname,
        search: newSearch ? "?".concat(newSearch) : '',
        hash: history.location.hash
      });
    }
  }, [draws, dispatch, selectedProduct, history, location.search, queryDrawNumber]);
  useEffect(() => {
    let isMounted = true;
    const fetchProductItems = async () => {
      const currentProductItems = await getProductItems({
        allProductNames: [selectedProduct],
        drawsByProduct: draws
      });
      if (isMounted && (!prevProductItemsRef.current || JSON.stringify(prevProductItemsRef.current) !== JSON.stringify(currentProductItems))) {
        setProductItems(currentProductItems);
      }
      prevProductItemsRef.current = currentProductItems;
    };
    fetchProductItems();
    return () => {
      isMounted = false;
    };
  }, [selectedProduct, draws]);
  if (activatedDrawId) {
    return draw ? React.createElement(DrawItemInfo, {
      className: "margin-bottom-1",
      isEdit: true,
      item: draw
    }) : null;
  }
  const drawItems = getDrawItems(draws[selectedProduct]);
  const currentSelectedDraw = localSelectedDraw || (queryDrawNumber ? parseInt(queryDrawNumber, 10) : selectedDraw);
  const selectedDrawIndex = drawItems.findIndex(_ref4 => {
    let item = _ref4.item,
      isDisabled = _ref4.isDisabled;
    return currentSelectedDraw === item.drawNumber || !currentSelectedDraw && !isDisabled;
  });
  if (selectedDrawIndex === -1) {
    return null;
  }
  const otherAvailableDrawItems = drawItems.filter((_ref5, index) => {
    let isDisabled = _ref5.isDisabled;
    return index !== selectedDrawIndex && !isDisabled;
  });
  if (otherAvailableDrawItems.length === 0) {
    return React.createElement(DrawItemInfo, {
      className: "padding-xs-top padding-xs-bottom",
      item: drawItems[selectedDrawIndex].item,
      showNetSale: true
    });
  }
  if (!productItems) {
    return null;
  }
  return React.createElement("div", {
    className: "control-group ".concat(isSelectedDrawClosed ? 'selected-draw-closed' : ''),
    "data-testid": "draw-selection"
  }, React.createElement(DropdownSelectItem, {
    className: "select-draw-list",
    onSelect: onSelectDraw,
    v2: true
  }, drawItems.map((_ref6, index) => {
    let item = _ref6.item,
      isDisabled = _ref6.isDisabled,
      disabledReason = _ref6.disabledReason;
    const _productItems$ = productItems[0],
      productName = _productItems$.item,
      _productItems$$jackpo = _productItems$.jackpots,
      jackpots = _productItems$$jackpo === void 0 ? [] : _productItems$$jackpo,
      _productItems$$funds = _productItems$.funds,
      funds = _productItems$$funds === void 0 ? [] : _productItems$$funds;
    const productId = resolveProductId(productName);
    const hasJackpotOrFunds = jackpots.length > 0 || funds.length > 0;
    return React.createElement(DropdownItem, {
      disabled: isDisabled,
      key: "".concat(item.key, "_").concat(item.name, "_").concat(item.regCloseTime),
      name: item.drawNumber,
      selected: index === selectedDrawIndex
    }, React.createElement(DrawItemInfo, {
      item: item
    }), Boolean(isDisabled) && React.createElement(DropdownLabel, {
      right: true
    }, React.createElement("div", {
      className: "qa-draw-selection-disabled-reason"
    }, disabledReason)), React.createElement(DropdownLabel, {
      right: true
    }, React.createElement("div", {
      className: "draw-selection-right-content"
    }, hasJackpotOrFunds && React.createElement("div", {
      className: "draw-selection-jackpot-funds"
    }, React.createElement(JackPotAndFunds, {
      drawNumber: item.drawNumber,
      funds: funds,
      jackpots: jackpots,
      productId: productId
    })), React.createElement("div", {
      className: "draw-selection-net-sale f-200"
    }, "Oms\xE4ttning: ".concat(formatCurrency(item.currentNetSale), " kr")))));
  })));
};
setGlobal('svs.components.marketplace.createGame.DrawSelection', DrawSelection);

 })(window);